export default __webpack_public_path__ + "static/assets/fe2b66210f6ecdc382c7658b0f4bd43f.png";